/**
 * Module Contrats — client API.
 *
 * Enveloppe les endpoints DRF montés sous `/api/contracts/` (cf. backend
 * `Contracts/urls.py`). Même trame que `santeApi` : toutes les requêtes
 * sont authentifiées (token) et `unwrap` déplie les listes paginées.
 */
import {
  makeGetRequest,
  makePostRequest,
  makePatchRequest,
  makeDeleteRequest,
} from '../../../utils/api'

const BASE = '/api/contracts/'

const ok = (r) => r && r.status >= 200 && r.status < 300
const unwrap = (r) => {
  if (!ok(r)) return null
  const d = r.data
  if (d && typeof d === 'object' && Array.isArray(d.results)) return d.results
  return d
}

// CRUD générique sur une collection (`/api/contracts/<resource>/`).
const collection = (resource) => ({
  list: async (params = '') =>
    unwrap(await makeGetRequest(`${BASE}${resource}/${params}`, {}, true)) || [],
  get: async (id) =>
    unwrap(await makeGetRequest(`${BASE}${resource}/${id}/`, {}, true)),
  create: async (body) =>
    unwrap(await makePostRequest(`${BASE}${resource}/`, body, {}, true)),
  update: async (id, body) =>
    unwrap(await makePatchRequest(`${BASE}${resource}/${id}/`, body, {}, true)),
  remove: async (id) =>
    ok(await makeDeleteRequest(`${BASE}${resource}/${id}/`, {}, true)),
})

export const contratsApi = {
  contracts: collection('contracts'),
  items: collection('items'),
  documents: collection('documents'),
  analyses: collection('analyses'),

  /** Upload d'un document (multipart). `file` peut être null (doc sans pièce). */
  uploadDocument: async ({ contract, title, document_type, document_date, file }) => {
    const formData = new FormData()
    formData.append('contract', contract)
    formData.append('title', title)
    formData.append('document_type', document_type || 'invoice')
    if (document_date) formData.append('document_date', document_date)
    if (file) formData.append('file', file)
    return unwrap(await makePostRequest(`${BASE}documents/`, formData, {}, true))
  },

  /**
   * Interprétation IA d'une facture. Renvoie la réponse brute (et non
   * `unwrap`) pour laisser l'appelant gérer le 402 (crédits insuffisants)
   * et le 422 (texte non extractible).
   */
  analyzeDocument: async (id) =>
    makePostRequest(`${BASE}documents/${id}/analyze/`, {}, {}, true),

  /** Consommations d'énergie agrégées — widget du dashboard écologie. */
  getConsumptionSummary: async () =>
    unwrap(await makeGetRequest(`${BASE}consumption-summary/`, {}, true)),
}
